export const StringLights = () => {
  return (
    <div className="fixed top-0 left-0 right-0 z-[40] pointer-events-none overflow-hidden">
      <svg 
        className="w-full h-12" 
        viewBox="0 0 1920 60" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
      >
        {/* Main wire/string */}
        <path
          d="M -50 12 Q 240 20 480 15 T 960 18 T 1440 15 T 1970 18"
          stroke="#D4AF37"
          strokeWidth="1"
          fill="none"
          opacity="0.6"
        />
        
        {/* Light bulbs along the string */}
        {[
          { x: 80, y: 14 },
          { x: 200, y: 18 },
          { x: 320, y: 16 },
          { x: 440, y: 15 },
          { x: 560, y: 17 },
          { x: 680, y: 16 },
          { x: 800, y: 18 },
          { x: 920, y: 17 },
          { x: 1040, y: 19 },
          { x: 1160, y: 17 },
          { x: 1280, y: 15 },
          { x: 1400, y: 16 },
          { x: 1520, y: 18 },
          { x: 1640, y: 16 },
          { x: 1760, y: 17 },
          { x: 1840, y: 18 }
        ].map((bulb, index) => (
          <g key={index}>
            {/* Wire holder */}
            <line
              x1={bulb.x}
              y1={bulb.y}
              x2={bulb.x}
              y2={bulb.y + 5}
              stroke="#D4AF37"
              strokeWidth="0.8"
              opacity="0.6"
            />
            
            {/* Socket/base (outline only) */}
            <rect
              x={bulb.x - 2}
              y={bulb.y + 4}
              width="4"
              height="4"
              stroke="#D4AF37"
              strokeWidth="0.8"
              fill="none"
              rx="0.5"
              opacity="0.6"
            />
            
            {/* Bulb (outline only, wider) */}
            <ellipse
              cx={bulb.x}
              cy={bulb.y + 14}
              rx="6"
              ry="7"
              stroke="#D4AF37"
              strokeWidth="1.2"
              fill="none"
              opacity="0.7"
            />
          </g>
        ))}
      </svg>
    </div>
  );
};
